import usePreventClickOnDrag from '@activities/MainActivity/components/MainBanners/hooks/usePreventClickOnDrag';
import Column from '@components/Column';
import Image from '@components/Image';
import Indicator from '@components/Indicator';
import styled from '@emotion/styled';
import { BannerRow } from '@models/banner';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import useGiftBanner from './hooks/useGiftBanner';

function Banner() {
    const banners = useGiftBanner();
    const { t } = useTranslation('gift');
    const [index, setIndex] = useState<number>(0);
    const { beforeChange, afterChange, onDragItemClick } = usePreventClickOnDrag();
    const onBannerClick = (banner: BannerRow) => {
    // TODO 배너 클릭 처리
        console.log(banner);
    };
    if (banners && banners.length > 0) {
        return (
            <Column align='center' fullWidth>
                {banners.length > 1 ? (
                    <Fragment>
                        <Slider dots={false}
                            beforeChange={beforeChange}
                            afterChange={(newIndex) => {
                                setIndex(newIndex);
                                afterChange();
                            }}>
                            {banners.map((banner, i) => (
                                <BannerWrapper onClick={() => {
                                    onDragItemClick(() => onBannerClick(banner));
                                }}
                                key={banner.contentId} >
                                    <BannerImage src={banner.imageUrl}
                                        alt={t('bannerAlt')} />
                                </BannerWrapper>
                            ))}
                        </Slider>
                        <Indicator total={banners.length}
                            current={index} />
                    </Fragment>
                ) : (
                    <BannerWrapper onClick={() => onBannerClick(banners[0])} >
                        <BannerImage src={banners[0].imageUrl}
                            alt={t('bannerAlt')} />
                    </BannerWrapper>
                )}
                {/*
              <Text size='xl' fontWeight='bold' color={colors.gray7}>
                  기간 한정 선물 EVENT
              </Text> */}
            </Column>
        );
    }
    return (<Fragment/>);
}

const BannerWrapper = styled.div`
    padding: 16px 20px;
    width: 100%;
`;

const BannerImage = styled(Image)`
    aspect-ratio: calc(40 / 21);
    border-radius: 8px;
    height: auto;
    width: 100%;
    object-fit: cover;
`;

export default Banner;
